import { render, staticRenderFns } from "./CandidateStatisticsMonthly.vue?vue&type=template&id=2dbcf300&"
import script from "./CandidateStatisticsMonthly.vue?vue&type=script&lang=js&"
export * from "./CandidateStatisticsMonthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports